import type { TailwindBreakpoints } from '@/app/types/styles/breakpoints';

export const TAILWIND_BREAKPOINTS_SIZE: Record<TailwindBreakpoints, number> = {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
  '3xl': 1920,
};
